import { render } from "./indexfourblog.vue?vue&type=template&id=63a618b3"
import script from "./indexfourblog.vue?vue&type=script&lang=js"
export * from "./indexfourblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__